import { render } from "./RaiseTicket.vue?vue&type=template&id=656a9c43"
import script from "./RaiseTicket.vue?vue&type=script&lang=js"
export * from "./RaiseTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__